import img1 from "../images/terrazas/img1.jpg";
import img2 from "../images/terrazas/img2.jpg";

export const imgTerrazas = [
  {
    id: 19101,
    image: img1
  },
  {
    id: 19102,
    image: img2
  } 
];